import { Badge } from 'corso-admin-ui';
import { CrewMerchantUi } from 'corso-types';
import { ComponentProps, PropsWithChildren } from 'react';

export const deliveryStatusVariant: Record<
  CrewMerchantUi.ConfigWebhookDelivery['status'],
  ComponentProps<typeof Badge>['variant']
> = {
  Delivered: 'success',
  Failed: 'danger',
  Pending: 'warning',
  Processing: 'default',
};

export function DeliveryDetailSection({
  title,
  children,
}: PropsWithChildren<{
  title: string;
}>) {
  return (
    <div>
      <p className="mb-1 text-sm font-medium text-neutral-700">{title}</p>
      {children}
    </div>
  );
}

export function JsonCodeBlock({
  content,
  maxHeight = 'max-h-96',
}: {
  content: string | object;
  maxHeight?: string;
}) {
  const formatted =
    typeof content === 'string'
      ? (() => {
          try {
            return JSON.stringify(JSON.parse(content), null, 2);
          } catch {
            return content;
          }
        })()
      : JSON.stringify(content, null, 2);

  return (
    <pre
      className={`${maxHeight} overflow-auto rounded border border-neutral-200 bg-neutral-50 p-3 text-xs`}
    >
      {formatted}
    </pre>
  );
}

export function DeliveryBadges({
  status,
  responseStatus,
}: {
  status: CrewMerchantUi.ConfigWebhookDelivery['status'];
  responseStatus?: number | null;
}) {
  return (
    <div className="flex items-center gap-2">
      <Badge variant={deliveryStatusVariant[status]}>{status}</Badge>
      {responseStatus != null && (
        <Badge variant="info">HTTP {responseStatus}</Badge>
      )}
    </div>
  );
}
